import { logEvent } from './analytics';
import { getSDKCommonParams, getGTParams } from './utils';
import type { EventData } from './types';

class AnalyticsCore {
    private isInitialized = false;

    constructor() {
        this.init();
    }

    private init() {
        try {
            this.isInitialized = true;
            this.startEventProcessing();
        } catch (error) {
            console.error('[Analytics SDK] Initialization failed:', error);
        }
    }

    private handleEvent(data: EventData) {
        const commonParams = getSDKCommonParams();
        const eventParams = getGTParams(data.eventName, data.params);

        // console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        // console.log('🔍 Source:', data.source);
        // console.log('🎯 Event Name:', data.eventName);
        // console.log('🔧 Common Params:', commonParams);
        // console.log('📦 Event Params:', eventParams);
        // console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

        logEvent(commonParams, eventParams);
    }

    private startEventProcessing() {
        const process = () => {
            const queue = window.__ANALYTICS_EVENT_QUEUE__;
            if (queue && queue.length > 0) {
                // Extract queued events and clear the queue
                const events = queue.splice(0, queue.length);
                events.forEach((data: any) => this.handleEvent(data));
            }
        };

        process();

        // Process as microtask
        Promise.resolve().then(process);
    }

    /**
     * Called directly by Analytics Event Hook in GTM
     */
    public onMappedEvent = (eventName: string, mappedParams: Record<string, any>) => {
        this.handleEvent({
            eventName,
            params: mappedParams,
            source: 'gtm',
        });
    };

    /**
     * Manual tracking call
     */
    public track = (eventName: string, params: Record<string, any> = {}) => {
        this.handleEvent({
            eventName,
            params,
            source: 'track',
        });
    };

    /**
     * Get SDK configuration
     */
    public getConfig = () => ({
        isInitialized: this.isInitialized,
        commonParams: getSDKCommonParams(),
    });
}

const isBrowser = typeof window !== 'undefined';
if (isBrowser && window.location.hostname !== 'dev.gumtree.io') {
    window.AnalyticsSDK = new AnalyticsCore();
}
export default AnalyticsCore;
